import eventHub from "@/eventHub";
// import store from "../store";
import { groupingRelationshipViewModel } from "@/models/groupingRelationshipViewModel";
import { tableImportMapping, tableImportMappingViewModel } from "@/models/importModels";
import { operationResult, operationResultStatus } from "@/models/operationResult";
import { tableItem } from "@/models/tableItem";
import axios, { AxiosInstance } from "axios";
import Qs from "qs";
import { groupItem } from "../models/groupItem";
import { schedulerItemViewModel } from "../models/schedulerItemViewModel";
import { connectionStringData } from "../models/connectionStringData";
import { UserLoggedInfoModel, UserLoginModel } from "@/models/userModels";

class Api {
	instance: AxiosInstance = null;
	_store: any = null;
	_connectionSelected: string = this._store ? this._store.getters.getConnectionSelected || "SfaStaging" : "SfaStaging";

	/**
	 * Ctor
	 */
	constructor() {
		this.instance = axios.create({
			baseURL: process.env.VUE_APP_BASE_URL
		});

		this.instance.interceptors.request.use(config => {
			//this._store.dispatch("increseRequestCount");
			config.headers.common["Authorization"] = "bearer " + localStorage.getItem("staging-management-token");
			config.paramsSerializer = params => {
				// Qs is already included in the Axios package
				return Qs.stringify(params, {
					arrayFormat: "repeat"
				});
			};
			return config;
		});
		// this.instance.interceptors.response.use(
		// 	response => {
		// 		this._store.dispatch("decreaseRequestCount");
		// 		return response;
		// 	},
		// 	error => {
		// 		this._store.dispatch("decreaseRequestCount");
		// 		eventHub.$emit(eventHub.events.AXIOS_RESPONSE_ERROR, error);
		// 		return Promise.reject(error);
		// 	}
		// );
		// if (store)
		//this._store.dispatch("setConnectionSelected", this._connectionSelected);
	}

	init(store): void {
		this._store = store;
		this.instance.interceptors.request.use(config => {
			this._store.dispatch("increseRequestCount");
			return config;
		});
		this.instance.interceptors.response.use(
			response => {
				this._store.dispatch("decreaseRequestCount");
				return response;
			},
			error => {
				this._store.dispatch("decreaseRequestCount");
				eventHub.$emit(eventHub.events.AXIOS_RESPONSE_ERROR, error);
				return Promise.reject(error);
			}
		);

		if (!this._store.getters.getConnectionSelected) {
			this._store.dispatch("setConnectionSelected", this._connectionSelected);
		}
		else {
			this._connectionSelected = this._store.getters.getConnectionSelected;
		}
	}

	//#region ** AUTHENTICATION **

	getUserInfo(): Promise<UserLoggedInfoModel> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.get<UserLoggedInfoModel>("/account/me")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	doLogout(): Promise<boolean> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.post("/logout")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	doJwtLogin(credencial: UserLoginModel): Promise<string> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.post<operationResult<string>>("login/jwtbearer", credencial)
				.then(res => {
					resolve(res.data.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	//[//#endregion]

	//#region ** CONNECTION STRINGS **

	getConnections(): Promise<connectionStringData[]> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.get<connectionStringData[]>("/connections")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	changeConnectionSelected(connectionId: string): void {
		this._connectionSelected = connectionId;
		this._store.dispatch("setConnectionSelected", this._connectionSelected);
	}

	//[//#endregion]

	//#region ** TABLE CONFIG **

	getTables(): Promise<tableItem[]> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.get<tableItem[]>(`/tables?connectionName=${self._connectionSelected}`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	getTableConfigs(tableName: string): Promise<tableImportMapping[]> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.get<tableImportMapping[]>(`/tables/${tableName}?connectionName=${self._connectionSelected}`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	postNewTableConfigs(table: tableImportMapping): Promise<number> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.post<operationResult<number>>(`/tables/mapping?connectionName=${self._connectionSelected}`, table)
				.then(res => {
					resolve(res.data.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	postNewCloneTableConfigs(itemID: number, tableName: string): Promise<number> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.post<operationResult<number>>(`/tables/config/clone/${itemID}/${tableName}?connectionName=${self._connectionSelected}`)
				.then(res => {
					resolve(res.data.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	postNewDuplicateTableConfigs(itemID: number, tableName: string): Promise<number> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.post<operationResult<number>>(`/tables/config/duplicate/${itemID}/${tableName}?connectionName=${self._connectionSelected}`)
				.then(res => {
					resolve(res.data.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	getImportConfiguration(id: number): Promise<tableImportMappingViewModel> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.get<tableImportMappingViewModel>(`/tables/config/${id}?connectionName=${self._connectionSelected}`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	postConfigDetail(configuration: tableImportMappingViewModel): Promise<boolean> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.post<operationResult<null>>(`tables/config?connectionName=${self._connectionSelected}`, configuration)
				.then(res => {
					if (res.data.status == operationResultStatus.ok) resolve(null);
					else reject(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	deleteTableConfig(itemId: number): Promise<operationResult<object>> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.delete<operationResult<object>>(`tables/config/${itemId}?connectionName=${self._connectionSelected}`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	uploadSchemaFile(itemId: number, f: File): Promise<string> {
		var self = this;

		return new Promise(function(resolve, reject) {
			// form.append("name", f.name);
			// form.append("file", f.stream);
			let formData = new FormData();
			formData.append("file", f);
			self.instance
				.post<operationResult<string>>(`tables/uploadschema/${itemId}?connectionName=${self._connectionSelected}`, formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(res => {
					if (res.data.status == operationResultStatus.ok) resolve(res.data.data);
					else reject(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	getSchemaFile(itemId: number): Promise<string[]> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.get<operationResult<string[]>>(`tables/schemafile/${itemId}?connectionName=${self._connectionSelected}`)
				.then(res => {
					if (res.data.status == operationResultStatus.ok) resolve((res.data.data as any).$values);
					else reject(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	//#endregion

	//#region ** GROUPS **
	getGroupings(): Promise<groupingRelationshipViewModel> {
		var self = this;
		return new Promise(function(resolve, reject) {
			self.instance
				.get<groupingRelationshipViewModel>("/groupings")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	saveNewGroup(group: groupItem): Promise<any> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.post(`/groupings/newgroup`, group)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	updateGroup(group: groupItem): Promise<any> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.post(`/groupings/updategroup`, group)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	deleteGroup(itemId: number): Promise<operationResult<object>> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.delete<operationResult<object>>(`groupings/delete/${itemId}`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}
	//#endregion

	//#region ** SCHEDULER **
	getSchedules(): Promise<schedulerItemViewModel[]> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.get<schedulerItemViewModel[]>("scheduler/schedules")
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	saveNewSchedule(schedule: schedulerItemViewModel): Promise<operationResult<any>> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.post(`scheduler/newschedule`, schedule)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	updateSchedule(schedule: schedulerItemViewModel): Promise<operationResult<any>> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.post(`/scheduler/updateschedule`, schedule)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	deleteSchedule(itemId: number): Promise<operationResult<any>> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.delete<operationResult<any>>(`scheduler/delete/${itemId}`)
				.then(res => {
					resolve(res.data);
				})
				.catch(err => {
					reject(err);
				});
		});
	}

	executeOnDemand(itemId: number): Promise<operationResult<any>> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.post<operationResult<any>>(`scheduler/ondemand/${itemId}`)
				.then(res => resolve(res.data))
				.catch(err => reject(err));
		});
	}

	executeOnDemandSettings(itemId: number): Promise<operationResult<any>> {
		var self = this;

		return new Promise(function(resolve, reject) {
			self.instance
				.post<operationResult<any>>(`scheduler/ondemand/new/${itemId}/1`)
				.then(res => resolve(res.data))
				.catch(err => reject(err));
		});
	}
	//#endregion
}

const api = new Api();
export default api;
